import React, { FC, forwardRef, Fragment, RefObject, useEffect } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import { uniqueId } from 'lodash';
import { config } from 'gsap';



export interface HorizontalListProps<T> {
    renderItem: (item: T) => JSX.Element
    items: T[],
    margin?: number
    itemClass?: string
    marginStart?: number
    marginEnd?: number
    containerRef?: RefObject<HTMLDivElement>
}

function HorizontalList<T>(props: HorizontalListProps<T>) {
    const classes = useStyles();
    const id = uniqueId('horizontal-list');


    const _renderItem = (item: T, index: number) => {
        return (
            <Fragment key={index}>
                {index === props.items.length - 1 ? <Box pl={props.marginStart} /> : null}
                <Box mx={props.margin || 4} className={props.itemClass ?? `${id}-item`}>
                    {props.renderItem(item)}
                </Box>
                {index === props.items.length - 1 ? <Box p={props.marginEnd} /> : null}
            </Fragment>
        )
    }

    return (
        <div ref={props.containerRef} className={classes.root} id={id}>
            {props.items.map(_renderItem)}
        </div>
    )
}




const useStyles = makeStyles<Theme, any>((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'flex-start',
        overflow: 'auto'
    }
}));

export default HorizontalList;